<!--  -->
<template>
    <div>
        <Header></Header>
        <div class="tabel">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="index" align="center" label="序号" width="180">
                </el-table-column>
                <el-table-column prop="content" align="center" label="督导内容">
                </el-table-column>
                <el-table-column prop="time" align="center" label="上传时间">
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template>
                        <el-button type="text" size="small" style="margin-left:10px" @click="preview">查看</el-button>
                        <el-button type="text" size="small" style="margin-left:10px" @click="edit">编辑</el-button>
                        <el-button type="text" size="small" style="margin-left:10px">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="myPage">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage2" :page-sizes="[8, 10]" :page-size="8"
                    layout=" prev, pager, next,sizes" :total="8">
                </el-pagination>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                currentPage2: 1,
                tableData: [{
                        index: 1,
                        content: '学校督导-核心价值观督导情况表',
                        time: '2023-01-02 11:40'
                    },
                    {
                        index: 2,
                        content: '学校督导-诊断式督导指标体系',
                        time: '2023-01-02 11:50'
                    }, {
                        index: 3,
                        content: '学校督导-综合督导课堂观察表',
                        time: '2023-01-02 11:52'
                    }, {
                        index: 4,
                        content: '教师督导-基本功测评',
                        time: '2023-01-02 11:55'
                    }, {
                        index: 5,
                        content: '教师督导-中小学课堂教学评价表',
                        time: '2023-01-02 12:00'
                    }, {
                        index: 6,
                        content: '教师督导-经常性督导评估用表-师德建设、教师专业发展情况',
                        time: '2023-01-03 10:40'
                    }, {
                        index: 7,
                        content: '学生督导-经常性督导评估用表',
                        time: '2023-01-04 11:40'
                    }, {
                        index: 8,
                        content: '学生督导-减负量表',
                        time: '2023-01-05 11:10'
                    },
                ],

            }
        },
        methods: {
            preview() {
                console.log('123')
                // this.$router.push('/view')
                this.$router.push({
                    path: '/view',
                })
            },
            edit() {
                this.$router.push({
                    path: '/edit',
                })
            },
            handleSizeChange() {},
            handleCurrentChange() {}
        },
        mounted() {},
    };
</script>
<style lang='less' scoped>
    @import url('./less/tabel.less');
</style>